import React from 'react';

import { Nullable } from '@tager/web-core';

import { PostFull } from '@/typings/model';

import MainView from './MainView';

type Props = {
  post: Nullable<PostFull>;
};

const Main = ({ post }: Props) => {
  return <MainView post={post} />;
};

export default Main;
